import React from 'react';
import { Instagram, Facebook, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-deepblack text-white pt-20 pb-10 border-t border-white/10" data-id="element-75">
      <div className="container mx-auto px-6 md:px-12" data-id="element-76">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-77">
          {/* Brand */}
          <div className="md:col-span-2" data-id="element-78">
            <a href="#" className="inline-flex flex-col items-start group mb-6" data-id="element-79">
              <span className="font-serif text-3xl tracking-wider text-white" data-id="element-80">
                AURA
              </span>
              <span className="font-sans text-xs tracking-[0.3em] text-rosegold font-light" data-id="element-81">
                ESTÉTICA
              </span>
            </a>
            <p className="text-white/60 font-sans font-light max-w-sm leading-relaxed" data-id="element-82">
              Donde tu belleza se transforma en arte. Clínica de medicina
              estética avanzada enfocada en resaltar tu mejor versión.
            </p>
          </div>

          {/* Links */}
          <div data-id="element-83">
            <h4 className="font-serif text-lg mb-6 text-white" data-id="element-84">Explorar</h4>
            <ul className="space-y-4 font-sans font-light text-white/60" data-id="element-85">
              <li data-id="element-86">
                <a href="#servicios" className="hover:text-rosegold transition-colors" data-id="element-87">
                  Tratamientos
                </a>
              </li>
              <li data-id="element-88">
                <a href="#resultados" className="hover:text-rosegold transition-colors" data-id="element-89">
                  Resultados
                </a>
              </li>
              <li data-id="element-90">
                <a href="#testimonios" className="hover:text-rosegold transition-colors" data-id="element-91">
                  Testimonios
                </a>
              </li>
              <li data-id="element-92">
                <a href="#contacto" className="hover:text-rosegold transition-colors" data-id="element-93">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div data-id="element-94">
            <h4 className="font-serif text-lg mb-6 text-white" data-id="element-95">Conectemos</h4>
            <div className="flex gap-4" data-id="element-96">
              <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white/80 hover:bg-rosegold hover:border-rosegold hover:text-white transition-all" data-id="element-97">
                <Instagram size={18} data-id="element-98" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white/80 hover:bg-rosegold hover:border-rosegold hover:text-white transition-all" data-id="element-99">
                <Facebook size={18} data-id="element-100" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white/80 hover:bg-rosegold hover:border-rosegold hover:text-white transition-all" data-id="element-101">
                <Mail size={18} data-id="element-102" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-103">
          <p className="text-white/40 font-sans text-sm font-light" data-id="element-104">
            © {new Date().getFullYear()} AURA Estética. Todos los derechos
            reservados.
          </p>
          <div className="flex gap-6 text-white/40 font-sans text-sm font-light" data-id="element-105">
            <a href="#" className="hover:text-white transition-colors" data-id="element-106">
              Políticas de Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-107">
              Términos y Condiciones
            </a>
          </div>
        </div>
      </div>
    </footer>;
}